import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { COLOR_CLASSES } from "@/lib/format";

export const UOM_OPTIONS = ["EA", "KG", "MT", "LTR", "SET", "BOX", "MTR"];
export const INCOTERM_OPTIONS = ["EXW", "FCA", "FOB", "CPT", "CIP", "DAP", "DPU", "DDP"];

export const INVITE_STATUS = {
  invited: { label: "Invited", color: "slate" },
  opened: { label: "Opened", color: "blue" },
  intends: { label: "Intends to Participate", color: "amber" },
  participated: { label: "Participated", color: "green" },
  declined: { label: "Declined", color: "red" },
  removed: { label: "Removed", color: "red" },
};

export function InviteStatusBadge({ status }) {
  const s = INVITE_STATUS[status] || { label: status || "—", color: "slate" };
  const c = COLOR_CLASSES[s.color];
  return (
    <span data-testid={`invite-status-${status}`} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${c.badge}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {s.label}
    </span>
  );
}

export const REVIEW_STATUS = {
  pending: { label: "Pending Review", color: "amber" },
  opened: { label: "Opened", color: "blue" },
  approved: { label: "Approved", color: "green" },
  rejected: { label: "Rejected", color: "red" },
  overdue: { label: "Overdue", color: "red" },
  removed: { label: "Removed", color: "slate" },
  review_required: { label: "Review Required", color: "amber" },
};

export const CATEGORY_OPTIONS = ["Raw Materials", "Packaging", "Maintenance", "Machinery", "IT", "Logistics",
                                 "Services", "Construction", "Chemicals", "Other"];

export function ReviewStatusBadge({ status, displayStatus }) {
  const key = displayStatus || status;
  const s = REVIEW_STATUS[key] || { label: key || "—", color: "slate" };
  const c = COLOR_CLASSES[s.color];
  return (
    <span data-testid={`review-status-${key}`} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${c.badge}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {s.label}
    </span>
  );
}

export function EnquiryOpenBadge({ passed }) {
  return passed ? (
    <span data-testid="enquiry-status-closed" className="inline-flex items-center gap-1.5 rounded-full border border-[#FECACA] bg-[#FEE2E2] px-2.5 py-0.5 text-xs font-medium text-[#991B1B]">
      <span className="h-1.5 w-1.5 rounded-full bg-[#EF4444]" /> Closed — timeline passed
    </span>
  ) : (
    <span data-testid="enquiry-status-open" className="inline-flex items-center gap-1.5 rounded-full border border-[#BBF7D0] bg-[#DCFCE7] px-2.5 py-0.5 text-xs font-medium text-[#166534]">
      <span className="h-1.5 w-1.5 rounded-full bg-[#22C55E]" /> Open
    </span>
  );
}

export async function downloadFile(url, filename) {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch (e) {
    toast.error("Download failed — you may not have access to this file");
  }
}
